<template>
<div class="chapter">
<div class="inner_page">
<div id="TOC">
<h1>Table of Contents</h1>
<p class="noindent"><a href="#/004dedication">Dedication</a></p>
<p class="noindent" id="introduction"><a href="#/005introduction">Introduction</a></p>
<p class="noindent" id="part1"><a href="#/006part1">Chapter 1 Souper Bowls—Soups and Chilies</a></p>
<blockquote>
<p class="hang" id="ch1"><a href="#/007chapter1">Totally Awesome Veggie Stock</a></p>
<p class="hang" id="ch2"><a href="#/008chapter2">Chicken Stock, the Slow-Cooker Method</a></p>
<p class="hang" id="ch3"><a href="#/009chapter3">Crocked Beef Stock</a></p>
<p class="hang" id="ch4"><a href="#/010chapter4">Turkey Carcass Broth</a></p>
<p class="hang" id="ch5"><a href="#/011chapter5">Minestrone with Parmigiano-Reggiano</a></p>
<p class="hang" id="ch6"><a href="#/012chapter6">Shiitake Mushroom Miso Soup</a></p>
<p class="hang" id="ch7"><a href="#/013chapter7">Triple Mushroom Soup</a></p>
<p class="hang" id="ch8"><a href="#/014chapter8">Creamy Onion Soup</a></p>
<p class="hang" id="ch9"><a href="#/015chapter9">Butternut Squash Soup</a></p>
<p class="hang" id="ch10"><a href="#/016chapter10">Ginger Pear Pumpkin Soup</a></p>
<p class="hang" id="ch11"><a href="#/017chapter11">Roasted Tomato Soup with Spinach Pesto</a></p>
<p class="hang" id="ch12"><a href="#/018chapter12">Creamy Broccoli Soup</a></p>
<p class="hang" id="ch13"><a href="#/019chapter13">Creamy Loaded Baked-Potato Soup</a></p>
<p class="hang" id="ch14"><a href="#/020chapter14">Julia’s Potato and Leek Soup</a></p>
<p class="hang" id="ch15"><a href="#/021chapter15">White Bean and Rosemary Soup</a></p>
<p class="hang" id="ch16"><a href="#/022chapter16">Nona’s Umbrian Lentil Soup</a></p>
<p class="hang" id="ch17"><a href="#/023chapter17">Grandma’s Che Che Bean Soup</a></p>
<p class="hang" id="ch18"><a href="#/024chapter18">Caribbean Black Bean Soup</a></p>
<p class="hang" id="ch19"><a href="#/025chapter19">Monterey Bay Bean Soup</a></p>
<p class="hang" id="ch20"><a href="#/026chapter20">Greens ‘n’ Beans Soup</a></p>
<p class="hang" id="ch21"><a href="#/027chapter21">Many Bean Soup</a></p>
<p class="hang" id="ch22"><a href="#/028chapter22">Vegetarian Confetti Split Pea Soup</a></p>
<p class="hang" id="ch23"><a href="#/029chapter23">Confetti Split Pea and Smoked Sausage Soup</a></p>
<p class="hang" id="ch24"><a href="#/030chapter24">Creamy Chicken and Wild Rice Soup</a></p>
<p class="hang" id="ch25"><a href="#/031chapter25">Chicken and Spinach Soup</a></p>
<p class="hang" id="ch26"><a href="#/032chapter26">Mom’s Chicken Noodle Goodness</a></p>
<p class="hang" id="ch27"><a href="#/033chapter27">Chicken, Mushroom, and Barley Soup</a></p>
<p class="hang" id="ch28"><a href="#/034chapter28">Chicken Tortilla Soup</a></p>
<p class="hang" id="ch29"><a href="#/035chapter29">Take-Me-to-the-Kasbah Chicken Vegetable Soup with Couscous</a></p>
<p class="hang" id="ch30"><a href="#/036chapter30">Raj Chicken Vegetable Soup</a></p>
<p class="hang" id="ch31"><a href="#/037chapter31">Saigon Chicken Rice Soup</a></p>
<p class="hang" id="ch32"><a href="#/038chapter32">Cajun Chicken Gumbo</a></p>
<p class="hang" id="ch33"><a href="#/039chapter33">Pacific Rim Pork and Noodle Soup</a></p>
<p class="hang" id="ch34"><a href="#/040chapter34">Turkey Minestrone</a></p>
<p class="hang" id="ch35"><a href="#/041chapter35">Italian Wedding Soup with Turkey Meatballs</a></p>
<p class="hang" id="ch36"><a href="#/042chapter36">Alphabet Beef Vegetable Soup</a></p>
<p class="hang" id="ch37"><a href="#/043chapter37">Old-Fashioned Beef and Barley Soup</a></p>
<p class="hang" id="ch38"><a href="#/044chapter38">Steak and Ale Soup</a></p>
<p class="hang" id="ch39"><a href="#/045chapter39">Steak and Mushroom Soup</a></p>
<p class="hang" id="ch40"><a href="#/046chapter40">Kansas City Steak Soup</a></p>
<p class="hang" id="ch41"><a href="#/047chapter41">Curried Meatball Soup</a></p>
<p class="hang" id="ch42"><a href="#/048chapter42">Portuguese Kale and Sausage Soup</a></p>
<p class="hang" id="ch43"><a href="#/049chapter43">Sopranos-Style Sausage Minestrone</a></p>
<p class="hang" id="ch44"><a href="#/050chapter44">Five-Alarm Hill-o’-Beans Chili</a></p>
<p class="hang" id="ch45"><a href="#/051chapter45">White Chicken Chili</a></p>
<p class="hang" id="ch46"><a href="#/052chapter46">Turkey, Corn, and Black Bean Chili</a></p>
<p class="hang" id="ch47"><a href="#/053chapter47">Super Bowl Sunday Chili</a></p>
<p class="hang" id="ch48"><a href="#/054chapter48">Ryan’s Chili</a></p>
<p class="hang" id="ch49"><a href="#/055chapter49">Lone Star Sirloin Chili</a></p>
<p class="hang" id="ch50"><a href="#/056chapter50">Back Bay Corn Chowder</a></p>
<p class="hang" id="ch51"><a href="#/057chapter51">New England Fish Chowder</a></p>
<p class="hang" id="ch52"><a href="#/058chapter52">Clam Chowder</a></p>
<p class="hang" id="ch53"><a href="#/059chapter53">Spicy Manhattan-Style Clam Chowder</a></p>
<p class="hang" id="ch54"><a href="#/060chapter54">Shrimp Chowder</a></p>
<p class="hang" id="ch55"><a href="#/061chapter55">Mixed Shellfish Chowder</a></p>
<p class="hang" id="ch56"><a href="#/062chapter56">Cajun Corn and Crab Soup</a></p>
<p class="hang" id="ch57"><a href="#/063chapter57">Mediterranean Shrimp and Rice Soup</a></p>
<p class="hang" id="ch58"><a href="#/064chapter58">Veracruz-Style Fish Soup</a></p>
<p class="hang" id="ch59"><a href="#/065chapter59">Miso Soup with Tofu, Shiitakes, and Shrimp</a></p>
<p class="hang" id="ch60"><a href="#/066chapter60">Sailors’ Shellfish Stew</a></p>
<p class="hang" id="ch61"><a href="#/067chapter61">Seafood Jambalaya</a></p>
</blockquote>
<p class="noindent" id="part2"><a href="#/068part2">Chapter 2 Is That a Casserole in There?</a></p>
<blockquote>
<p class="hang" id="ch62"><a href="#/069chapter62">Not-Your-Mother’s Tuna Noodle Casserole</a></p>
<p class="hang" id="ch63"><a href="#/070chapter63">Lasagna alla Bolognese</a></p>
<p class="hang" id="ch64"><a href="#/071chapter64">Pecorino Romano Lasagna</a></p>
<p class="hang" id="ch65"><a href="#/072chapter65">Penne Lasagna</a></p>
<p class="hang" id="ch66"><a href="#/073chapter66">Salmon, Artichoke, and Noodle Casserole</a></p>
<p class="hang" id="ch67"><a href="#/074chapter67">Sun-Dried Tomato Pesto and Tortellini Casserole</a></p>
<p class="hang" id="ch68"><a href="#/075chapter68">Old-Fashioned Mac and Cheese</a></p>
<p class="hang" id="ch69"><a href="#/076chapter69">Porcini and Sage Rice</a></p>
<p class="hang" id="ch70"><a href="#/077chapter70">Chicken, Artichoke, and Mushroom Rice Casserole</a></p>
<p class="hang" id="ch71"><a href="#/078chapter71">Green Chile and Sour Cream Rice Casserole</a></p>
<p class="hang" id="ch72"><a href="#/079chapter72">Chicken and Triple Mushroom Casserole</a></p>
<p class="hang" id="ch73"><a href="#/080chapter73">Arancini Casserole</a></p>
<p class="hang" id="ch74"><a href="#/081chapter74">Enchiladas Verde</a></p>
<p class="hang" id="ch75"><a href="#/082chapter75">Chicken Enchiladas with Ranchero Sauce</a></p>
<p class="hang" id="ch76"><a href="#/083chapter76">Beef Enchiladas with Chipotle Sauce</a></p>
<p class="hang" id="ch77"><a href="#/084chapter77">King Ranch Casserole</a></p>
<p class="hang" id="ch78"><a href="#/085chapter78">Tamale Pie</a></p>
</blockquote>
<p class="noindent" id="part3"><a href="#/086part3">Chapter 3 A Chicken or Turkey in Every Pot</a></p>
<blockquote>
<p class="hang" id="ch79"><a href="#/087chapter79">Chicken Balsamico with Yukon Gold Potatoes</a></p>
<p class="hang" id="ch80"><a href="#/088chapter80">Bistro Chicken Thighs</a></p>
<p class="hang" id="ch81"><a href="#/089chapter81">Smoked-Paprika Chicken Thighs</a></p>
<p class="hang" id="ch82"><a href="#/090chapter82">Chicken Cacciatore with Porcini and Cremini Mushrooms</a></p>
<p class="hang" id="ch83"><a href="#/091chapter83">Barbecued Chicken Legs</a></p>
<p class="hang" id="ch84"><a href="#/092chapter84">Braised Chicken with Niçzise Olives</a></p>
<p class="hang" id="ch85"><a href="#/093chapter85">Chicken Dijonaise</a></p>
<p class="hang" id="ch86"><a href="#/094chapter86">Tandoori Chicken</a></p>
<p class="hang" id="ch87"><a href="#/095chapter87">Fruited Chicken Tagine</a></p>
<p class="hang" id="ch88"><a href="#/096chapter88">Braised Chicken in Stout</a></p>
<p class="hang" id="ch89"><a href="#/097chapter89">Southern Brunswick Stew</a></p>
<p class="hang" id="ch90"><a href="#/098chapter90">Braised Basque Chicken</a></p>
<p class="hang" id="ch91"><a href="#/099chapter91">Spicy Asian Braised Napa Cabbage Wraps</a></p>
<p class="hang" id="ch92"><a href="#/100chapter92">Basic Poached Chicken Breasts</a></p>
<p class="hang" id="ch93"><a href="#/101chapter93">Chicken with Miso and Broccoli</a></p>
<p class="hang" id="ch94"><a href="#/102chapter94">Boursin and Spinach–Stuffed Chicken Breasts</a></p>
<p class="hang" id="ch95"><a href="#/103chapter95">Chicken with Figs and Balsamic Vinegar</a></p>
<p class="hang" id="ch96"><a href="#/104chapter96">Tarragon Chicken</a></p>
<p class="hang" id="ch97"><a href="#/105chapter97">Boneless Buffalo Chicken for Sandwiches</a></p>
<p class="hang" id="ch98"><a href="#/106chapter98">Chicken Braised in Cider with Apples and Bacon</a></p>
<p class="hang" id="ch99"><a href="#/107chapter99">Curried Chicken Divan</a></p>
<p class="hang" id="ch100"><a href="#/108chapter100">Old-Fashioned Chicken Pot Pie</a></p>
<p class="hang" id="ch101"><a href="#/109chapter101">Chicken Meatballs in Chunky Tomato Sauce</a></p>
<p class="hang" id="ch102"><a href="#/110chapter102">Jamaican Chicken</a></p>
<p class="hang" id="ch103"><a href="#/111chapter103">Barbecued Turkey</a></p>
<p class="hang" id="ch104"><a href="#/112chapter104">Turkey Braised in Tomato Sauce</a></p>
<p class="hang" id="ch105"><a href="#/113chapter105">Garlicky Lemon and Thyme Turkey</a></p>
<p class="hang" id="ch106"><a href="#/114chapter106">Teriyaki Turkey Thighs</a></p>
<p class="hang" id="ch107"><a href="#/115chapter107">Tea “Smoked” Turkey Legs</a></p>
<p class="hang" id="ch108"><a href="#/116chapter108">Artichoke-Stuffed Turkey Breast Cutlets</a></p>
<p class="hang" id="ch109"><a href="#/117chapter109">Salsa Turkey Loaf</a></p>
<p class="hang" id="ch110"><a href="#/118chapter110">Asian Meatballs</a></p>
<p class="hang" id="ch111"><a href="#/119chapter111">Rosemary Lemon Wings</a></p>
<p class="hang" id="ch112"><a href="#/120chapter112">Frank’s Hot-Sauce Buffalo Wings</a></p>
<p class="hang" id="ch113"><a href="#/121chapter113">Thai Peanut Wings</a></p>
<p class="hang" id="ch114"><a href="#/122chapter114">Asian Honey Wings</a></p>
<p class="hang" id="ch115"><a href="#/123chapter115">Le Bambou Vietnamese Wings</a></p>
</blockquote>
<p class="noindent" id="part4"><a href="#/124part4">Chapter 4 Something Fishy Going On</a></p>
<blockquote>
<p class="hang" id="ch116"><a href="#/125chapter116">Acadiana Shrimp Barbecue</a></p>
<p class="hang" id="ch117"><a href="#/126chapter117">Beantown Scallops</a></p>
<p class="hang" id="ch118"><a href="#/127chapter118">Garlic Crab Claws</a></p>
<p class="hang" id="ch119"><a href="#/128chapter119">Bouillabaisse</a></p>
<p class="hang" id="ch120"><a href="#/129chapter120">Catalan-Style Seafood Stew</a></p>
<p class="hang" id="ch121"><a href="#/130chapter121">Poached Miso Salmon</a></p>
<p class="hang" id="ch122"><a href="#/131chapter122">Poached Salmon Provenç</a></p>
<p class="hang" id="ch123"><a href="#/132chapter123">Olive Oil–Poached Tuna</a></p>
<p class="hang" id="ch124"><a href="#/133chapter124">Sea Bass Tagine</a></p>
<p class="hang" id="ch125"><a href="#/134chapter125">Lemon, Garlic, and Butter Halibut</a></p>
<p class="hang" id="ch126"><a href="#/135chapter126">South-of-the-Border Halibut</a></p>
<p class="hang" id="ch127"><a href="#/136chapter127">Sole Pizzaiola</a></p>
<p class="hang" id="ch128"><a href="#/137chapter128">Miso-Glazed Cod</a></p>
<p class="hang" id="ch129"><a href="#/138chapter129">Poached Salmon Cakes in White Wine Butter Sauce</a></p>
<p class="hang" id="ch130"><a href="#/139chapter130">Pacifica Sweet-Hot Salmon</a></p>
<p class="hang" id="ch131"><a href="#/140chapter131">Potato-Crusted Sea Bass</a></p>
</blockquote>
<p class="noindent" id="part5"><a href="#/141part5">Chapter 5 Let’s Beef It Up</a></p>
<blockquote>
<p class="hang" id="ch132"><a href="#/142chapter132">Pot Roast Italiano</a></p>
<p class="hang" id="ch133"><a href="#/143chapter133">Not-So-Swiss Steak</a></p>
<p class="hang" id="ch134"><a href="#/144chapter134">Asian Braised Beef in Sake</a></p>
<p class="hang" id="ch135"><a href="#/145chapter135">Southwestern Beef Rolls</a></p>
<p class="hang" id="ch136"><a href="#/146chapter136">Mediterranean Beef Rolls</a></p>
<p class="hang" id="ch137"><a href="#/147chapter137">Beef in Barolo</a></p>
<p class="hang" id="ch138"><a href="#/148chapter138">North African Beef Stew</a></p>
<p class="hang" id="ch139"><a href="#/149chapter139">Old-Fashioned Beef Stew with Vegetables</a></p>
<p class="hang" id="ch140"><a href="#/150chapter140">Beef Braciole</a></p>
<p class="hang" id="ch141"><a href="#/151chapter141">Shirley’s Sunday Pot Roast</a></p>
<p class="hang" id="ch142"><a href="#/152chapter142">Beef Fajitas-Style</a></p>
<p class="hang" id="ch143"><a href="#/153chapter143">Hungarian Smoked Beef Braise</a></p>
<p class="hang" id="ch144"><a href="#/154chapter144">Porcini Pot Roast</a></p>
<p class="hang" id="ch145"><a href="#/155chapter145">Sirloin Teriyaki</a></p>
<p class="hang" id="ch146"><a href="#/156chapter146">All-I-Want-Is-Meat-and-Potatoes Sirloin</a></p>
<p class="hang" id="ch147"><a href="#/157chapter147">Red Wine–Marinated Sirloin</a></p>
<p class="hang" id="ch148"><a href="#/158chapter148">Santa Maria Tri-Tip for Fajitas</a></p>
<p class="hang" id="ch149"><a href="#/159chapter149">Barbecued Beef Sandwiches</a></p>
<p class="hang" id="ch150"><a href="#/160chapter150">Shepherd’s Pie</a></p>
<p class="hang" id="ch151"><a href="#/161chapter151">Mashed Potatoes for Stews or Pot Pies</a></p>
<p class="hang" id="ch152"><a href="#/162chapter152">Bistro Dijon Sirloin</a></p>
<p class="hang" id="ch153"><a href="#/163chapter153">Corned Beef and Cabbage Braised in Riesling</a></p>
<p class="hang" id="ch154"><a href="#/164chapter154">Corned Beef with Guinness</a></p>
<p class="hang" id="ch155"><a href="#/165chapter155">Brisket with Dried Fruits</a></p>
<p class="hang" id="ch156"><a href="#/166chapter156">Old-Fashioned Beef Brisket with Root Vegetables</a></p>
<p class="hang" id="ch157"><a href="#/167chapter157">Barbecued Brisket</a></p>
<p class="hang" id="ch158"><a href="#/168chapter158">Texas Smoked Brisket</a></p>
<p class="hang" id="ch159"><a href="#/169chapter159">Meat Loaf Italiano with Chunky Tomato Sauce</a></p>
<p class="hang" id="ch160"><a href="#/170chapter160">Diner-Style Meat Loaf with Gravy</a></p>
<p class="hang" id="ch161"><a href="#/171chapter161">Old-Fashioned Meat Loaf</a></p>
<p class="hang" id="ch162"><a href="#/172chapter162">Meatballs Italiano</a></p>
<p class="hang" id="ch163"><a href="#/173chapter163">Curried Meatballs</a></p>
<p class="hang" id="ch164"><a href="#/174chapter164">Mom’s Stuffed Cabbage Rolls</a></p>
<p class="hang" id="ch165"><a href="#/175chapter165">Lazy-Day Cabbage Rolls</a></p>
<p class="hang" id="ch166"><a href="#/176chapter166">Flank Steak with Spinach, Bacon, and Mushroom Stuffing</a></p>
<p class="hang" id="ch167"><a href="#/177chapter167">Artichoke-Stuffed Flank Steak with Red Wine Sauce</a></p>
<p class="hang" id="ch168"><a href="#/178chapter168">Salsa Beef Fajitas</a></p>
<p class="hang" id="ch169"><a href="#/179chapter169">Chicago-Style Italian Beef</a></p>
<p class="hang" id="ch170"><a href="#/180chapter170">Pacific Rim Braised Short Ribs</a></p>
<p class="hang" id="ch171"><a href="#/181chapter171">Pub-Crawl Short Ribs</a></p>
<p class="hang" id="ch172"><a href="#/182chapter172">Barbecue-Style Short Ribs</a></p>
<p class="hang" id="ch173"><a href="#/183chapter173">Lemon Garlic Short Ribs</a></p>
<p class="hang" id="ch174"><a href="#/184chapter174">Zinfandel-Braised Short Ribs</a></p>
<p class="hang" id="ch175"><a href="#/185chapter175">Hot Italian Short Ribs</a></p>
<p class="hang" id="ch176"><a href="#/186chapter176">Veal Shanks Osso Bucco–Style</a></p>
<p class="hang" id="ch177"><a href="#/187chapter177">Veal Chops Braised in White Wine and Sage</a></p>
<p class="hang" id="ch178"><a href="#/188chapter178">Veal Chops Braised with Confetti Peppers</a></p>
<p class="hang" id="ch179"><a href="#/189chapter179">Veal Stew with Forty Cloves of Garlic</a></p>
<p class="hang" id="ch180"><a href="#/190chapter180">Sage-Scented Veal and Sausage Stew</a></p>
<p class="hang" id="ch181"><a href="#/191chapter181">Veal Paprikash</a></p>
</blockquote>
<p class="noindent" id="part6"><a href="#/192part6">Chapter 6 Whole Hog</a></p>
<blockquote>
<p class="hang" id="ch182"><a href="#/193chapter182">Shoulder</a></p>
<p class="hang" id="ch183"><a href="#/194chapter183">Pulled Pork</a></p>
<p class="hang" id="ch184"><a href="#/195chapter184">Cinco de Mayo Pork</a></p>
<p class="hang" id="ch185"><a href="#/196chapter185">Pork Shoulder Shanghai-Style</a></p>
<p class="hang" id="ch186"><a href="#/197chapter186">Pork Chalupa-Style</a></p>
<p class="hang" id="ch187"><a href="#/198chapter187">Umbrian Porchetta</a></p>
<p class="hang" id="ch188"><a href="#/199chapter188">Pork Chops with Sauerkraut and Apples</a></p>
<p class="hang" id="ch189"><a href="#/200chapter189">South-of-the-Border Pork Chops</a></p>
<p class="hang" id="ch190"><a href="#/201chapter190">Pork Chops with Sage and Balsamic Vinegar</a></p>
<p class="hang" id="ch191"><a href="#/202chapter191">Smothered Pork Chops</a></p>
<p class="hang" id="ch192"><a href="#/203chapter192">Sweet Potato Pork Chop Supper</a></p>
<p class="hang" id="ch193"><a href="#/204chapter193">Just-Peachy Pork Chops</a></p>
<p class="hang" id="ch194"><a href="#/205chapter194">Maple Bourbon Pork Chops</a></p>
<p class="hang" id="ch195"><a href="#/206chapter195">Plum Sauce Pork Chops</a></p>
<p class="hang" id="ch196"><a href="#/207chapter196">Cranberry Orange Pork Loin</a></p>
<p class="hang" id="ch197"><a href="#/208chapter197">Pork Loin Braised in Cider with Apples and Cream</a></p>
<p class="hang" id="ch198"><a href="#/209chapter198">Pork Loin in Plum Bourbon Sauce</a></p>
<p class="hang" id="ch199"><a href="#/210chapter199">Orange Chipotle Pork Loin</a></p>
<p class="hang" id="ch200"><a href="#/211chapter200">Sugar and Spice Pork Loin</a></p>
<p class="hang" id="ch201"><a href="#/212chapter201">Apricot-Mustard Glazed Pork Loin</a></p>
<p class="hang" id="ch202"><a href="#/213chapter202">Braised Pork Loin with Riesling and Red Cabbage</a></p>
<p class="hang" id="ch203"><a href="#/214chapter203">Pork Tenderloin Osso Bucco–Style</a></p>
<p class="hang" id="ch204"><a href="#/215chapter204">Pork Tenderloin Stuffed with Cranberry Wild Rice with Cranberry Sauce</a></p>
<p class="hang" id="ch205"><a href="#/216chapter205">Pork Tenderloin Stuffed with Cornbread Dressing with Red Wine Sauce</a></p>
<p class="hang" id="ch206"><a href="#/217chapter206">Jamaican Jerk Pork Tenderloin in Mango Sauce</a></p>
<p class="hang" id="ch207"><a href="#/218chapter207">Chile Relleno Pork Tenderloin with Ranchero Sauce</a></p>
<p class="hang" id="ch208"><a href="#/219chapter208">Teriyaki Pork Tenderloin</a></p>
<p class="hang" id="ch209"><a href="#/220chapter209">Asian Barbecued Baby Back Ribs</a></p>
<p class="hang" id="ch210"><a href="#/221chapter210">Barbecued Baby Back Ribs</a></p>
<p class="hang" id="ch211"><a href="#/222chapter211">Mediterranean-Style Spareribs</a></p>
<p class="hang" id="ch212"><a href="#/223chapter212">Country-Style Ribs with Sauerkraut</a></p>
<p class="hang" id="ch213"><a href="#/224chapter213">Braised Asian Spareribs</a></p>
<p class="hang" id="ch214"><a href="#/225chapter214">Choucroute Garni</a></p>
<p class="hang" id="ch215"><a href="#/226chapter215">Brats ‘n’ Beer</a></p>
<p class="hang" id="ch216"><a href="#/227chapter216">Pushcart Sausage and Peppers</a></p>
<p class="hang" id="ch217"><a href="#/228chapter217">Smoky Sausage in Barbecue Sauce</a></p>
<p class="hang" id="ch218"><a href="#/229chapter218">Old-Fashioned Franks and Beans</a></p>
<p class="hang" id="ch219"><a href="#/230chapter219">Hawaiian Sausages</a></p>
<p class="hang" id="ch220"><a href="#/231chapter220">Crocked Ham and Scalloped Potatoes</a></p>
<p class="hang" id="ch221"><a href="#/232chapter221">Barbecue-Style Ham Loaf</a></p>
</blockquote>
<p class="noindent" id="part7"><a href="#/233part7">Chapter 7 Ewe’ll Love This!</a></p>
<blockquote>
<p class="hang" id="ch222"><a href="#/234chapter222">Leg of Lamb Stuffed with Mint Pesto</a></p>
<p class="hang" id="ch223"><a href="#/235chapter223">Zinfandel-Braised Leg of Lamb</a></p>
<p class="hang" id="ch224"><a href="#/236chapter224">Lamb Tex-Mex–Style with Pinto Beans</a></p>
<p class="hang" id="ch225"><a href="#/237chapter225">Lemon Dijon Leg of Lamb</a></p>
<p class="hang" id="ch226"><a href="#/238chapter226">Lamb Shanks Braised Osso Bucco–Style</a></p>
<p class="hang" id="ch227"><a href="#/239chapter227">Lamb Shanks Braised in Ale</a></p>
<p class="hang" id="ch228"><a href="#/240chapter228">Lamb Cassoulet with White Beans and Rosemary</a></p>
<p class="hang" id="ch229"><a href="#/241chapter229">Lamb Curry</a></p>
<p class="hang" id="ch230"><a href="#/242chapter230">Lamb Tagine</a></p>
<p class="hang" id="ch231"><a href="#/243chapter231">Braised Lamb with Eggplant, Tomatoes, and Feta</a></p>
<p class="hang" id="ch232"><a href="#/244chapter232">Mediterranean Lamb with Green Beans, Potatoes, and Mint</a></p>
<p class="hang" id="ch233"><a href="#/245chapter233">North African Lamb with Lemon and Artichokes</a></p>
<p class="hang" id="ch234"><a href="#/246chapter234">Lentils and Lamb, Mediterranean-Style</a></p>
<p class="hang" id="ch235"><a href="#/247chapter235">Tandoori-Style Lamb</a></p>
<p class="hang" id="ch236"><a href="#/248chapter236">Cottage Pie</a></p>
<p class="hang" id="ch237"><a href="#/249chapter237">Dubliner Stew</a></p>
<p class="hang" id="ch238"><a href="#/250chapter238">Curried Lamb Meatballs</a></p>
<p class="hang" id="ch239"><a href="#/251chapter239">Mediterranean Gyros-Style Meatballs</a></p>
</blockquote>
<p class="noindent" id="part8"><a href="#/252part8">Chapter 8 On the Side</a></p>
<blockquote>
<p class="hang" id="ch240"><a href="#/253chapter240">Saffron Rice</a></p>
<p class="hang" id="ch241"><a href="#/254chapter241">Bulgur with Basil, Mint, and Tomato</a></p>
<p class="hang" id="ch242"><a href="#/255chapter242">Polenta</a></p>
<p class="hang" id="ch243"><a href="#/256chapter243">Risotto alla Milanese</a></p>
<p class="hang" id="ch244"><a href="#/257chapter244">Butternut Squash Risotto</a></p>
<p class="hang" id="ch245"><a href="#/258chapter245">Risotto with Gorgonzola</a></p>
<p class="hang" id="ch246"><a href="#/259chapter246">Bulgur and Shiitake Mushroom Pilaf</a></p>
<p class="hang" id="ch247"><a href="#/260chapter247">White and Wild Rice Pilaf</a></p>
<p class="hang" id="ch248"><a href="#/261chapter248">Fruited Wild Rice Pilaf</a></p>
<p class="hang" id="ch249"><a href="#/262chapter249">Basil and Pine Nut Pilaf</a></p>
<p class="hang" id="ch250"><a href="#/263chapter250">Classic Bread Stuffing</a></p>
<p class="hang" id="ch251"><a href="#/264chapter251">Cornbread Stuffing</a></p>
<p class="hang" id="ch252"><a href="#/265chapter252">French Onion Stuffing</a></p>
<p class="hang" id="ch253"><a href="#/266chapter253">Colonial Williamsburg Spoon Bread</a></p>
<p class="hang" id="ch254"><a href="#/267chapter254">Basic Grits</a></p>
<p class="hang" id="ch255"><a href="#/268chapter255">Cheesy Grits Casserole</a></p>
</blockquote>
<p class="noindent" id="part9"><a href="#/269part9">Chapter 9 Eat Your Veggies</a></p>
<blockquote>
<p class="hang" id="ch256"><a href="#/270chapter256">Refried Bean Casserole</a></p>
<p class="hang" id="ch257"><a href="#/271chapter257">Caribbean Black Beans</a></p>
<p class="hang" id="ch258"><a href="#/272chapter258">Creamy White Beans</a></p>
<p class="hang" id="ch259"><a href="#/273chapter259">Veggie Cassoulet</a></p>
<p class="hang" id="ch260"><a href="#/274chapter260">Cowboy-Style Baked Beans</a></p>
<p class="hang" id="ch261"><a href="#/275chapter261">Garbanzos Tuscan-Style</a></p>
<p class="hang" id="ch262"><a href="#/276chapter262">Southern-Style Green Beans</a></p>
<p class="hang" id="ch263"><a href="#/277chapter263">Roasted Beets with Goat Cheese and Pomegranate Dressing</a></p>
<p class="hang" id="ch264"><a href="#/278chapter264">Eggplant Parmigiana</a></p>
<p class="hang" id="ch265"><a href="#/279chapter265">Ratatouille</a></p>
<p class="hang" id="ch266"><a href="#/280chapter266">Caponata</a></p>
<p class="hang" id="ch267"><a href="#/281chapter267">Fennel Gratin</a></p>
<p class="hang" id="ch268"><a href="#/282chapter268">A Word about Potatoes</a></p>
<p class="hang" id="ch269"><a href="#/283chapter269">Potatoes Baked in the Crock</a></p>
<p class="hang" id="ch270"><a href="#/284chapter270">Rosemary and Garlic Potatoes</a></p>
<p class="hang" id="ch271"><a href="#/285chapter271">German Potato Salad with Sausage</a></p>
<p class="hang" id="ch272"><a href="#/286chapter272">Ultimate Mashed Potatoes</a></p>
<p class="hang" id="ch273"><a href="#/287chapter273">Mom’s Buttered and Parsleyed Potatoes</a></p>
<p class="hang" id="ch274"><a href="#/288chapter274">Potatoes Boulangerie</a></p>
<p class="hang" id="ch275"><a href="#/289chapter275">Potatoes Pizzaiola</a></p>
<p class="hang" id="ch276"><a href="#/290chapter276">Five-Spice-Glazed Sweet Potatoes</a></p>
<p class="hang" id="ch277"><a href="#/291chapter277">Maple Chipotle–Glazed Sweets</a></p>
<p class="hang" id="ch278"><a href="#/292chapter278">Crock-Baked Sweets</a></p>
<p class="hang" id="ch279"><a href="#/293chapter279">Apple Praline Sweet Potato Gratin</a></p>
<p class="hang" id="ch280"><a href="#/294chapter280">Orange-Thyme Glazed Carrots</a></p>
<p class="hang" id="ch281"><a href="#/295chapter281">Caramelized Onions</a></p>
<p class="hang" id="ch282"><a href="#/296chapter282">Creamed Pearl Onions with Sherry and Mushrooms</a></p>
<p class="hang" id="ch283"><a href="#/297chapter283">Stuffed Onions</a></p>
<p class="hang" id="ch284"><a href="#/298chapter284">Cippolini Onions with Balsamic Glaze</a></p>
<p class="hang" id="ch285"><a href="#/299chapter285">Braised Root Vegetables</a></p>
<p class="hang" id="ch286"><a href="#/300chapter286">Cabbage Braised with Riesling and Caraway</a></p>
<p class="hang" id="ch287"><a href="#/301chapter287">Cider-Braised Red Cabbage</a></p>
<p class="hang" id="ch288"><a href="#/302chapter288">Spinach Parmesan Strata</a></p>
<p class="hang" id="ch289"><a href="#/303chapter289">Butternut Squash Braised with Thyme and Cider</a></p>
<p class="hang" id="ch290"><a href="#/304chapter290">Apples and Sauerkraut</a></p>
<p class="hang" id="ch291"><a href="#/305chapter291">Peperonata</a></p>
<p class="hang" id="ch292"><a href="#/306chapter292">Stuffed Peppers</a></p>
<p class="hang" id="ch293"><a href="#/307chapter293">Stuffed Tomatoes</a></p>
<p class="hang" id="ch294"><a href="#/308chapter294">All-American Stewed Tomatoes</a></p>
<p class="hang" id="ch295"><a href="#/309chapter295">South-of-the-Border Stewed Tomatoes</a></p>
<p class="hang" id="ch296"><a href="#/310chapter296">Herbed Cherry Tomatoes</a></p>
<p class="hang" id="ch297"><a href="#/311chapter297">Zucchini, Tomato, and Leek Gratin</a></p>
<p class="hang" id="ch298"><a href="#/312chapter298">Yellow Squash Crock Casserole</a></p>
<p class="hang" id="ch299"><a href="#/313chapter299">Tomato, Corn, and Yellow Squash with Dill Butter</a></p>
<p class="hang" id="ch300"><a href="#/314chapter300">Ultimate Creamed Corn</a></p>
<p class="hang" id="ch301"><a href="#/315chapter301">Corn on the Cob, Slow Cooked</a></p>
</blockquote>
<p class="noindent" id="part10"><a href="#/316part10">Chapter 10 Something Saucy and Spicy Going On</a></p>
<blockquote>
<p class="hang" id="ch302"><a href="#/317chapter302">Sausage Gravy</a></p>
<p class="hang" id="ch303"><a href="#/318chapter303">Chicken Gravy</a></p>
<p class="hang" id="ch304"><a href="#/319chapter304">Turkey Gravy</a></p>
<p class="hang" id="ch305"><a href="#/320chapter305">Beef Gravy</a></p>
<p class="hang" id="ch306"><a href="#/321chapter306">Red Wine and Beef Sauce</a></p>
<p class="hang" id="ch307"><a href="#/322chapter307">Marinara Sauce</a></p>
<p class="hang" id="ch308"><a href="#/323chapter308">Bolognese Sauce</a></p>
<p class="hang" id="ch309"><a href="#/324chapter309">Vegan Pasta Sauce</a></p>
<p class="hang" id="ch310"><a href="#/325chapter310">Mom’s Sunday Sauce</a></p>
<p class="hang" id="ch311"><a href="#/326chapter311">Berry Good Sauce</a></p>
<p class="hang" id="ch312"><a href="#/327chapter312">Strawberry Rhubarb Sauce</a></p>
<p class="hang" id="ch313"><a href="#/328chapter313">Applesauce</a></p>
<p class="hang" id="ch314"><a href="#/329chapter314">Pumpkin Butter</a></p>
<p class="hang" id="ch315"><a href="#/330chapter315">Pear Butter</a></p>
<p class="hang" id="ch316"><a href="#/331chapter316">Five-Spice Pear Sauce</a></p>
<p class="hang" id="ch317"><a href="#/332chapter317">Just-Peachy Sauce</a></p>
<p class="hang" id="ch318"><a href="#/333chapter318">Peach Melba Sauce</a></p>
<p class="hang" id="ch319"><a href="#/334chapter319">Mango Chutney</a></p>
<p class="hang" id="ch320"><a href="#/335chapter320">Apple Pear Chutney</a></p>
<p class="hang" id="ch321"><a href="#/336chapter321">Cranberry Chutney</a></p>
<p class="hang" id="ch322"><a href="#/337chapter322">Apple Cranberry Compote</a></p>
<p class="hang" id="ch323"><a href="#/338chapter323">Cranberry Port Sauce</a></p>
<p class="hang" id="ch324"><a href="#/339chapter324">Margarita Cranberry Sauce</a></p>
<p class="hang" id="ch325"><a href="#/340chapter325">Not-Your-Mom’s Cranberry Orange Sauce</a></p>
<p class="hang" id="ch326"><a href="#/341chapter326">Strawberry Jam</a></p>
<p class="hang" id="ch327"><a href="#/342chapter327">Bellini Peach Jam</a></p>
<p class="hang" id="ch328"><a href="#/343chapter328">Orange Margarita Marmalade</a></p>
</blockquote>
<p class="noindent" id="part11"><a href="#/344part11">Chapter 11 What’s for Dessert?</a></p>
<blockquote>
<p class="hang" id="ch329"><a href="#/345chapter329">Brandied Peaches</a></p>
<p class="hang" id="ch330"><a href="#/346chapter330">Crock-Baked Apples</a></p>
<p class="hang" id="ch331"><a href="#/347chapter331">Amaretto Poached Pears</a></p>
<p class="hang" id="ch332"><a href="#/348chapter332">Red Wine Poached Pears with Stilton</a></p>
<p class="hang" id="ch333"><a href="#/349chapter333">Five-Spice Asian Pears</a></p>
<p class="hang" id="ch334"><a href="#/350chapter334">Strawberry Rhubarb Crumble</a></p>
<p class="hang" id="ch335"><a href="#/351chapter335">Almond Pear Crumble</a></p>
<p class="hang" id="ch336"><a href="#/352chapter336">Caramel Peaches with Praline Crumble</a></p>
<p class="hang" id="ch337"><a href="#/353chapter337">Apple Cranberry Cobbler</a></p>
<p class="hang" id="ch338"><a href="#/354chapter338">Hot Lemon Blueberry Pudding Cake</a></p>
<p class="hang" id="ch339"><a href="#/355chapter339">Hot Fudge Upside-Down Cake</a></p>
<p class="hang" id="ch340"><a href="#/356chapter340">Mexican Hot Chocolate Lava Cake</a></p>
<p class="hang" id="ch341"><a href="#/357chapter341">Perfect Crème Brûlée</a></p>
<p class="hang" id="ch342"><a href="#/358chapter342">Pots de Crème</a></p>
<p class="hang" id="ch343"><a href="#/359chapter343">Mom’s Old-Fashioned Rice Pudding</a></p>
<p class="hang" id="ch344"><a href="#/360chapter344">Coconut Jasmine Rice Pudding</a></p>
<p class="hang" id="ch345"><a href="#/361chapter345">Chai Tea Rice Pudding</a></p>
<p class="hang" id="ch346"><a href="#/362chapter346">Old-Fashioned Tapioca Pudding</a></p>
<p class="hang" id="ch347"><a href="#/363chapter347">Peach Melba Bread Pudding</a></p>
<p class="hang" id="ch348"><a href="#/364chapter348">Cappuccino Bread Pudding</a></p>
<p class="hang" id="ch349"><a href="#/365chapter349">Double Chocolate Croissant Bread Pudding</a></p>
<p class="hang" id="ch350"><a href="#/366chapter350">Piña Colada Bread Pudding</a></p>
<p class="hang" id="ch351"><a href="#/367chapter351">Coconutty Bread Pudding</a></p>
<p class="hang" id="ch352"><a href="#/368chapter352">Down East Indian Pudding</a></p>
<p class="hang" id="ch353"><a href="#/369chapter353">Grape-Nuts Custard Pudding</a></p>
</blockquote>
<p class="noindent" id="part12"><a href="#/370part12">Chapter 12 Party in a Pot</a></p>
<blockquote>
<p class="hang" id="ch354"><a href="#/371chapter354">Mulled Red Wine</a></p>
<p class="hang" id="ch355"><a href="#/372chapter355">Warm Mulled Cider</a></p>
<p class="hang" id="ch356"><a href="#/373chapter356">Spiced Cranberry Cider</a></p>
<p class="hang" id="ch357"><a href="#/374chapter357">Hot Buttered Rum Cider</a></p>
<p class="hang" id="ch358"><a href="#/375chapter358">Warm Cranberry Punch</a></p>
<p class="hang" id="ch359"><a href="#/376chapter359">Wassail</a></p>
<p class="hang" id="ch360"><a href="#/377chapter360">Luxurious Hot Cocoa</a></p>
<p class="hang" id="ch361"><a href="#/378chapter361">White Chocolate Mocha</a></p>
<p class="hang" id="ch362"><a href="#/379chapter362">Orange-Spiced Coffee</a></p>
<p class="hang" id="ch363"><a href="#/380chapter363">Everyone’s Favorite Snack Mix</a></p>
<p class="hang" id="ch364"><a href="#/381chapter364">Spicy Crocked Nuts</a></p>
<p class="hang" id="ch365"><a href="#/382chapter365">The Best Artichoke Spinach Dip on the Planet</a></p>
<p class="hang" id="ch366"><a href="#/383chapter366">Hot Broccoli Dip</a></p>
<p class="hang" id="ch367"><a href="#/384chapter367">Refried Bean Dip</a></p>
<p class="hang" id="ch368"><a href="#/385chapter368">Southwestern Chili con Queso</a></p>
<p class="hang" id="ch369"><a href="#/386chapter369">Hot Dill and Swiss Dip</a></p>
<p class="hang" id="ch370"><a href="#/387chapter370">Pizza Dip</a></p>
<p class="hang" id="ch371"><a href="#/388chapter371">Seafood Dip</a></p>
<p class="hang" id="ch372"><a href="#/389chapter372">Warm Clam Dip</a></p>
<p class="hang" id="ch373"><a href="#/390chapter373">Mornay Dip for Crab Claws and Shrimp</a></p>
<p class="hang" id="ch374"><a href="#/391chapter374">Hot Bloody Mary Dip for Shrimp</a></p>
<p class="hang" id="ch375"><a href="#/392chapter375">Maytag Blue and Walnut Dip with Apple Dippers</a></p>
<p class="hang" id="ch376"><a href="#/393chapter376">Roasted Tomato and Mozzarella Bruschetta</a></p>
<p class="hang" id="ch377"><a href="#/394chapter377">Orange Chipotle Wings</a></p>
<p class="hang" id="ch378"><a href="#/395chapter378">Spicy Rasta Wings</a></p>
<p class="hang" id="ch379"><a href="#/396chapter379">Kielbasa in Spicy Barbecue Sauce</a></p>
<p class="hang" id="ch380"><a href="#/397chapter380">Little Smokeys in Barbecue Sauce</a></p>
<p class="hang" id="ch381"><a href="#/398chapter381">Curried Chicken with Coconut and Basil</a></p>
<p class="hang" id="ch382"><a href="#/399chapter382">Prosciutto, Fig, and Fontina Stuffed Chicken Breasts</a></p>
<p class="hang" id="ch383"><a href="#/400chapter383">Stuffed Chicken Parmigiana</a></p>
<p class="hang" id="ch384"><a href="#/401chapter384">Chicken Breasts with Cornbread Stuffing</a></p>
<p class="hang" id="ch385"><a href="#/402chapter385">Chicken Breasts in Port Wine Smothered with Leeks</a></p>
<p class="hang" id="ch386"><a href="#/403chapter386">The Best Thanksgiving Turkey Breast You’ll Ever Eat</a></p>
<p class="hang" id="ch387"><a href="#/404chapter387">Stuffed Turkey Breast Braised in Pinot Grigio</a></p>
<p class="hang" id="ch388"><a href="#/405chapter388">Pork Chops Smothered in Figs and Sweet Onions</a></p>
<p class="hang" id="ch389"><a href="#/406chapter389">Cranberry Cinnamon Glazed Pork Loin</a></p>
<p class="hang" id="ch390"><a href="#/407chapter390">Ham with Spicy Mustard Glaze</a></p>
<p class="hang" id="ch391"><a href="#/408chapter391">Coca-Cola Ham</a></p>
<p class="hang" id="ch392"><a href="#/409chapter392">Stuffed Lamb in Ratatouille Sauce</a></p>
<p class="hang" id="ch393"><a href="#/410chapter393">Beef Stroganoff</a></p>
<p class="hang" id="ch394"><a href="#/411chapter394">Overnight Oatmeal</a></p>
<p class="hang" id="ch395"><a href="#/412chapter395">Huevos Rancheros</a></p>
<p class="hang" id="ch396"><a href="#/413chapter396">Egg Casseroles</a></p>
<p class="hang" id="ch397"><a href="#/414chapter397">Basic Strata</a></p>
<p class="hang" id="ch398"><a href="#/415chapter398">Croque Monsieur Strata</a></p>
<p class="hang" id="ch399"><a href="#/416chapter399">Salmon and Dill Strata</a></p>
<p class="hang" id="ch400"><a href="#/417chapter400">Sausage and Hash-Brown Casserole</a></p>
<p class="hang" id="ch401"><a href="#/418chapter401">Zucchini and Leek Frittata</a></p>
<p class="hang" id="ch402"><a href="#/419chapter402">Green Beans with Cippolini Onions and Cremini Mushrooms</a></p>
<p class="hang" id="ch403"><a href="#/420chapter403">Stuffed Artichokes</a></p>
<p class="hang" id="ch404"><a href="#/421chapter404">Wine-Braised Artichokes</a></p>
<p class="hang" id="ch405"><a href="#/422chapter405">Shaved Brussels Sprouts with Pancetta</a></p>
<p class="hang" id="ch406"><a href="#/423chapter406">Diva Mashed Potatoes</a></p>
<p class="hang" id="ch407"><a href="#/424chapter407">Grown-Up Mac and Cheese</a></p>
<p class="hang" id="ch408"><a href="#/425chapter408">Hot Fudge Sundae Sauce</a></p>
<p class="hang" id="ch409"><a href="#/426chapter409">Bananas Foster Bread Pudding</a></p>
<p class="hang" id="ch410"><a href="#/427chapter410">Ginger Cheesecake</a></p>
<p class="hang" id="ch411"><a href="#/428chapter411">Pumpkin Maple Bread Pudding</a></p>
<p class="hang" id="ch412"><a href="#/429chapter412">Stewed Figs in Port Wine with Point Reyes Blue Cheese</a></p>
<p class="hang" id="ch413"><a href="#/430chapter413">NOLA Bread Pudding with Whiskey Sauce</a></p>
<p class="hang" id="ch414"><a href="#/431chapter414">Cherries Jubilee Lava Cake</a></p>
</blockquote>
<p class="noindent" id="acknowledgments"><a href="#/432acknowledgments">Acknowledgments</a></p>
<p class="noindent" id="index"><a href="#/433index">Index</a></p>
<p class="noindent" id="tableofequivalents"><a href="#/434tableofequivalents">Table of Equivalents</a></p>
<p class="noindent" id="copyright"><a href="#/435copyright">Copyright</a></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 003-toc.vue?74908ba5